import { Divider } from "@mui/material";
import { grey } from "@mui/material/colors";
import { useDispatch } from "react-redux";
import CreateEditForm from "../components/finalForm/CreateEditForm";
import RffDateField from "../components/finalForm/inputs/RffDateField";
import RffPhoneField from "../components/finalForm/inputs/RffPhoneField";
import RffSelectToggleField from "../components/finalForm/inputs/RffSelectToggleField";
import RffTextField from "../components/finalForm/inputs/RffTextField";
import RffGroup from "../components/finalForm/shared/RffGroup";
import Flx from "../components/layout/Flx";
import { useEndpointHook } from "../hooks/useEndpointHook";
import { profileClear, profileSet } from "../redux/actions/profileActions";
import { sidebarClose } from "../redux/reducers/sidebarReducer";
import { UploadFileContent } from "../components/modals/common/FileUploadModal";

const UploadProfileDocumentsForm = ({ isEditing, initialValues, metadata }) => {
  // console.log("UploadProfileDocumentsForm", metadata);
  const dispatch = useDispatch();
  const { loading, uploadProfileDocuments } = useEndpointHook();

  const handleOnSubmit = (f) => {
    // console.log(f);
    // return;
    uploadProfileDocuments({
      files: f,

      onSuccessFn: () => {
        dispatch(profileClear());
        dispatch(sidebarClose());
      },
    });
  };

  return (
    <UploadFileContent
      onSubmit={handleOnSubmit}
      loading={loading}
      initialFiles={[]}
      docGroup={metadata?.docGroup}
      docType={metadata?.docType}
    />
  );
  // if (isEditing) {
  //   return (
  //     <CreateEditForm
  //       onUpdate={onUpdate}
  //       loading={loading}
  //       initialValues={initialValues}
  //       updateButtonText="Update Bank Information"
  //     >
  //       <BankInfoFormQuestions />
  //     </CreateEditForm>
  //   );
  // }
  // return (
  //   <CreateEditForm
  //     onCreate={onCreate}
  //     loading={loading}
  //     createButtonText="Add Bank"
  //   >
  //     <BankInfoFormQuestions />
  //   </CreateEditForm>
  // );
};

const BankInfoFormQuestions = ({ disabled }) => {
  return (
    <Flx column g={4}>
      <RffGroup suppressBottomMargin title="Bank Information">
        <RffTextField
          name="bankAccountNumber"
          label="Bank Account Number"
          helperText="Enter the bank account number for the payment account."
        />
        <RffTextField name="bankRoutingNumber" label="Bank Routing Number" />
        <RffTextField name="nameOfBank" label="Name Of Bank" />
        <RffPhoneField name="bankPhoneNumber" label="Bank Phone Number" />
      </RffGroup>
      <Divider sx={{ my: 2, borderColor: grey[200] }} />
      <RffGroup title="Personal Details">
        <RffTextField
          name="bankAccountOwnerName"
          label="Bank Account Owner Name"
        />
        <RffTextField
          name="preferredPaymentMethod"
          label="Preferred Payment Method"
          helperText="Examples: Check, wire transfer, ect..."
        />
        <RffSelectToggleField
          name="bankAccountOwnerType"
          label="Bank Account Owner Type"
          options={["Individual", "Entity"]}
        />
        <RffDateField size={6} name="lastWireDate" label="Last Wire Date" />
        <RffDateField
          size={6}
          name="lastWireVerificationDate"
          label="Last Wire Verification Date"
        />
      </RffGroup>

      {/* <FieldArray name="entityMembers">
        {({ fields }) => (
          <Box sx={{ width: "100%" }}>
            <Flx fw ac wrap jb g={1} sx={{ mb: 2 }}>
              <Flx column>
                <Txt bold>Entity Members</Txt>
                <Txt secondary>Add members or managers of this entity.</Txt>
              </Flx>
              <Button
                disabled={disabled}
                variant="outlined"
                startIcon={<AddOutlined />}
                onClick={() =>
                  fields.push({
                    firstName: "",
                    lastName: "",
                    middleName: "",
                    fullName: "",
                    entityPercentOwnership: 0,
                    isGuarantor: false,
                    title: "",
                  })
                }
                //   sx={{ mt: 1, m: "0 auto" }}
              >
                Add Entity Member
              </Button>
            </Flx>
            {fields.map((name, index) => (
              <Box
                key={name}
                sx={{
                  mb: 2,
                  border: `1px solid ${grey[300]}`,
                  borderRadius: 2,
                  position: "relative",
                }}
              >
                <Flx
                  fw
                  jb
                  sx={{
                    mb: 2,
                    px: 2,
                    py: 1.5,
                    //   background: grey[50],
                    borderBottom: `1px solid ${grey[200]}`,
                  }}
                >
                  <Txt sx={{ fontStyle: "italic" }} bold>
                    Member {index + 1}
                  </Txt>
                  <IconButton
                    size="small"
                    color="error"
                    onClick={() => fields.remove(index)}
                    sx={{
                      position: "absolute",
                      top: 8,
                      right: 8,
                    }}
                  >
                    <DeleteOutline fontSize="small" />
                  </IconButton>
                </Flx>

                <RffGroup gap={2} sx={{ p: 2 }}>
                  <RffTextField
                    disabled={disabled}
                    name={`${name}.firstName`}
                    label="First Name"
                    size={4}
                  />
                  <RffTextField
                    disabled={disabled}
                    name={`${name}.middleName`}
                    label="Middle Name"
                    size={4}
                  />
                  <RffTextField
                    disabled={disabled}
                    name={`${name}.lastName`}
                    label="Last Name"
                    size={4}
                  />
                  <RffPercentField
                    name={`${name}.entityPercentOwnership`}
                    label="Ownership Percentage"
                    //   size={4}
                  />

                  <RffSelectToggleField
                    name={`${name}.title`}
                    size={6}
                    disabled={disabled}
                    label="Title/Role"
                    options={[
                      { label: "Manager", value: "Manager" },
                      { label: "Member", value: "Member" },
                      { label: "Officer", value: "Officer" },
                      { label: "Other", value: "Other" },
                    ]}
                  />
                  <RffBooleanToggleField
                    disabled={disabled}
                    name={`${name}.isGuarantor`}
                    label="Is Guarantor?"
                    size={6}
                  />
                </RffGroup>
              </Box>
            ))}
          </Box>
        )}
      </FieldArray> */}
    </Flx>
  );
};

const DUMMY = {
  bankAccountNumber: "123456789012",
  bankRoutingNumber: "021000021",
  nameOfBank: "Chase Bank",
  bankPhoneNumber: "2125557890",

  bankAccountOwnerName: "James Oliva",
  preferredPaymentMethod: "Wire transfer",
  bankAccountOwnerType: "Individual",

  lastWireDate: "2025-01-15",
  lastWireVerificationDate: "2025-01-16",
};
export default UploadProfileDocumentsForm;
